<template lang="pug">
UpsertBookingPanel(title="Customer")
  template(v-slot:heading-action="")
    BriqButton(small @click="toggle" :variant="buttonVariant" data-test-id="new-find-customer-button") {{ buttonText }}
  template(v-slot:body="")
    NewCustomer(v-if="isNewCustomer" :lastSearchQuery="lastSearchQuery")
    FindCustomer(v-else @selected="selected" ref="findCustomer" @lastSearchQuery="setLastSearchQuery")
</template>

<script>
import UpsertBookingPanel from '@v/bookings/edit/components/UpsertBookingPanel.vue'
import NewCustomer from './PanelCustomer/NewCustomer.vue'
import FindCustomer from './PanelCustomer/FindCustomer.vue'

// This panel can be in one of three states:
const PanelState = Object.freeze({
  FIND: 'FIND', // look for an existing customer
  NEW: 'NEW', // create a new customer
  SELECTED: 'SELECTED', // an existing customer has been selected
})

export default {
  name: 'PanelCustomer',
  components: { UpsertBookingPanel, NewCustomer, FindCustomer },
  props: { booking: { type: Object, required: true } },
  data() {
    return {
      panelState: PanelState.FIND,
      lastSearchQuery: '',
    }
  },
  computed: {
    buttonText() {
      if (this.panelState === PanelState.FIND) return 'New customer'
      if (this.panelState === PanelState.SELECTED) return 'Change customer'
      return 'Find customer'
    },
    buttonVariant() {
      if (this.panelState === PanelState.FIND) return 'main'
      return 'secondary'
    },
    isNewCustomer() {
      return this.panelState === PanelState.NEW
    },
  },
  methods: {
    setLastSearchQuery(searchQuery) {
      this.lastSearchQuery = searchQuery
    },
    setPanelState(state) {
      this.panelState = state
      if (state !== PanelState.SELECTED) this.booking.CustomerKey = null
    },
    toggle() {
      switch (this.panelState) {
        case PanelState.NEW:
          this.setPanelState(PanelState.FIND)
          this.lastSearchQuery = ''
          break
        case PanelState.SELECTED:
          this.$refs.findCustomer.reset()
          this.setPanelState(PanelState.FIND)
          break
        case PanelState.FIND:
          this.setPanelState(PanelState.NEW)
          break
      }
    },
    selected(customerKey) {
      this.booking.CustomerKey = customerKey
      this.setPanelState(PanelState.SELECTED)
    },
  },
}
</script>
